import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from 'react-leaflet';
import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import { useMap } from "react-leaflet";

const ChangeView = ({ lat, lng }) => {
    const map = useMap();

    useEffect(() => {
        if (lat && lng) {
            map.setView([lat, lng], 16); // zoom tùy bạn
        }
    }, [lat, lng]);

    return null;
};

// fix icon lỗi marker
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapEvents = ({ setFormData }) => {
    useMapEvents({
        click(e) {
            setFormData((prev) => ({
                ...prev,
                latitude: e.latlng.lat.toFixed(6),
                longitude: e.latlng.lng.toFixed(6),
            }));
        },
    });
    return null;
};


const DraggableCircle = ({ center, radius }) => {
    return (
        <Circle
            center={center}
            radius={radius}
            pathOptions={{ color: 'blue' }}
        />
    );
};

const MapSection = ({ formData, setFormData }) => {
    const mapRef = useRef();

    const lat = parseFloat(formData.latitude);
    const lng = parseFloat(formData.longitude);
    const radius = parseFloat(formData.radius) || 0;

    // 👉 sync input → map
    useEffect(() => {
        if (!isNaN(lat) && !isNaN(lng) && mapRef.current) {
            mapRef.current.setView([lat, lng], 16);
        }
    }, [lat, lng]);

    return (
        <MapContainer
            center={[10.8231, 106.6297]}
            zoom={13}
            className="h-full w-full rounded-xl"
            whenCreated={(map) => (mapRef.current = map)}
        >
            <TileLayer
                attribution="&copy; OpenStreetMap"
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <ChangeView
                lat={Number(formData.latitude)}
                lng={Number(formData.longitude)}
            />

            <MapEvents setFormData={setFormData} />

            {!isNaN(lat) && !isNaN(lng) && (
                <>
                    <Marker position={[lat, lng]} />

                    {radius > 0 && (
                        <DraggableCircle
                            center={[lat, lng]}
                            radius={radius}
                            setFormData={setFormData}
                        />
                    )}
                </>
            )}
        </MapContainer>
    );
};

export default MapSection;